import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { issueNavigatorGlobalJiraRoute } from '@atlassian/jira-router-routes-issue-navigator-routes/src/issueNavigatorGlobalJiraRoute.tsx';
import { GlobalIssueNavigatorSkeleton } from '@atlassian/jira-skeletons/src/ui/issue-navigator/components/global-app.tsx';
import { NIN_NEW_ISSUE_NAVIGATOR } from '@atlassian/jira-capabilities/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getCommonGlobalNavigation } from './common/getCommonGlobalNavigation.tsx';
import { getCommonGlobalResources } from './common/getCommonGlobalResources.tsx';
import { getRouteReporting } from './common/getRouteReporting.tsx';
import {
	globalIssueNavigatorGinRedirectPageEntryPoint,
	globalIssueNavigatorPageEntryPoint,
} from './ui/index.tsx';

/**
 * Global Issue Navigator Route Entry
 * Handles the new `/jira/issues` route scheme
 */
export const issueNavigatorGlobalJiraRouteEntry = createEntry(
	issueNavigatorGlobalJiraRoute,
	() => ({
		group: 'issue-navigator',
		apdexIgnoreParams: ['issueKey'],

		meta: {
			capability: NIN_NEW_ISSUE_NAVIGATOR,
			reporting: getRouteReporting(),
		},

		skeleton: GlobalIssueNavigatorSkeleton,
		ufoName: 'global-issue-navigator-jfe',
		navigation: getCommonGlobalNavigation(),
		resources: [...getCommonGlobalResources()],
		layout: globalLayout,
		entryPoint: () =>
			fg('nin_remove_global_scope_enrolment')
				? globalIssueNavigatorPageEntryPoint
				: globalIssueNavigatorGinRedirectPageEntryPoint,
		supportsPreviewPanel: true,

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-issue-navigator-entries/src/issueNavigatorGlobalJiraRouteEntry.tsx',
				whichExportToUse: 'issueNavigatorGlobalJiraRouteEntry',
			},

			enabled: true,
		},
	}),
);
